import * as React from 'react'
import { useEffect } from 'react'
import { Script } from 'gatsby'
import Layout from '../components/layout'
import SiteHeader from '../components/site-header'

import '../styles/reset.css'
import '../styles/pages/index.scss'

import pcLogo from '../images/64876617-0-poker-coaching-logo-.webp'
import checkIcon from '../images/64876656-0-green-checkmark-circ.webp'
import wordsImg from '../images/64883250-0-pc-home-page-words1.gif'
import img5 from '../images/65285913-0-cgmc-play-600.jpg'
import img6 from '../images/65285941-0-cash-game-challenge-.webp'
import img7 from '../images/65285943-0-crushing-tough-cg-pl.webp'
import jlImg from '../images/1734255904-64912793-573x501x573x501x0x0-jl-blueshirt-patch.webp'
import coachesCollage from '../images/1734255922-64913308-1180x285-coaches-collage3.webp'
import img10 from '../images/1734255923-64914321-762x67x956x67x0x0-Logo-SingleLine-Mult.webp'
import img11 from '../images/1734255927-64914792-130x130x130x130x0x0-peter-hsu.jpg'
import img13 from '../images/1735808435-64914649-130x130-anthony-m.jpg'
import img14 from '../images/1735808438-65065865-532x82-PEAK-LOGO-960.png'

const IndexPage = () => {
  useEffect(() => {
    const dropdowns = document.querySelectorAll('.dropdown')

    dropdowns.forEach((dropdown) => {
      const link = dropdown.querySelector('a')

      link.addEventListener('click', function (event) {
        event.preventDefault()

        dropdowns.forEach((item) => {
          if (item !== dropdown) {
            item.classList.remove('dd-active')
          }
        })

        dropdown.classList.toggle('dd-active')
      })
    })

    document.addEventListener('click', function (event) {
      if (!event.target.closest('.dropdown')) {
        dropdowns.forEach((dropdown) => dropdown.classList.remove('dd-active'))
      }
    })

    trainingSubMenu()
    freeResourcesSubMenu()

    function trainingSubMenu() {
      const menuItems = document.querySelectorAll('.training li a')
      const image = document.querySelector('.training .submenu-right-block img')
      const button = document.querySelector('.training .submenu-right-block a')

      menuItems.forEach((item) => {
        item.addEventListener('mouseenter', function () {
          menuItems.forEach((menuItem) =>
            menuItem.classList.remove('selected-submenu-item')
          )
          this.classList.add('selected-submenu-item')

          const targetId = this.getAttribute('data-target')
          switch (targetId) {
            case 'img1':
              image.setAttribute(
                'src',
                'https://pokercoaching.com/wp-content/uploads/2024/01/CASH-GAME.jpg'
              )
              button.setAttribute(
                'href',
                'https://pokercoaching.com/cash-game-masterclass'
              )
              break
            case 'img2':
              image.setAttribute(
                'src',
                'https://pokercoaching.com/wp-content/uploads/2024/01/TOURNAMENT.png'
              )
              button.setAttribute(
                'href',
                'https://pokercoaching.com/tournament-masterclass'
              )
              break
            case 'img3':
              image.setAttribute(
                'src',
                'https://pokercoaching.com/wp-content/uploads/2024/01/ADVANCED.jpg'
              )
              button.setAttribute(
                'href',
                'https://pokercoaching.com/advanced-cash-game-course'
              )
              break
            case 'img4':
              image.setAttribute(
                'src',
                'https://pokercoaching.com/wp-content/uploads/2024/01/ADVANCED-1.jpg'
              )
              button.setAttribute(
                'href',
                'https://pokercoaching.com/advanced-tournament-course'
              )
              break
            case 'img5':
              image.setAttribute(
                'src',
                'https://pokercoaching.com/wp-content/uploads/2024/02/64686830-0-heros-journey1280-e1708344110828.jpg'
              )
              button.setAttribute(
                'href',
                'https://pokercoaching.com/heros-journey'
              )
              break
            default:
              image.setAttribute(
                'src',
                'https://pokercoaching.com/wp-content/uploads/2024/01/CASH-GAME.jpg'
              )
              button.setAttribute(
                'href',
                'https://pokercoaching.com/cash-game-masterclass'
              )
              break
          }
        })
      })
    }

    function freeResourcesSubMenu() {
      const menuItems = document.querySelectorAll('.free-resources li a')
      const image = document.querySelector(
        '.free-resources .submenu-right-block img'
      )
      const button = document.querySelector(
        '.free-resources .submenu-right-block a'
      )

      menuItems.forEach((item) => {
        item.addEventListener('mouseenter', function () {
          menuItems.forEach((menuItem) =>
            menuItem.classList.remove('selected-submenu-item')
          )
          this.classList.add('selected-submenu-item')

          const targetId = this.getAttribute('data-target')
          switch (targetId) {
            case 'img1':
              image.setAttribute(
                'src',
                'https://pokercoaching.com/wp-content/uploads/2024/01/poker-ebooks-500.jpg'
              )
              button.setAttribute(
                'href',
                'https://pokercoaching.com/poker-ebooks'
              )
              break
            case 'img2':
              image.setAttribute(
                'src',
                'https://pokercoaching.com/wp-content/uploads/2024/01/cash-ebooks-500.jpg'
              )
              button.setAttribute(
                'href',
                'https://pokercoaching.com/cash-game-ebooks'
              )
              break
            case 'img3':
              image.setAttribute(
                'src',
                'https://pokercoaching.com/wp-content/uploads/2024/01/tournament-ebooks-500.jpg'
              )
              button.setAttribute(
                'href',
                'https://pokercoaching.com/tournament-ebooks'
              )
              break
            case 'img4':
              image.setAttribute(
                'src',
                'https://pokercoaching.com/wp-content/uploads/2024/01/downloadable-preflop-charts-500.jpg'
              )
              button.setAttribute(
                'href',
                'https://pokercoaching.com/preflop-charts'
              )
              break
            case 'img5':
              image.setAttribute(
                'src',
                'https://pokercoaching.com/wp-content/uploads/2024/01/downloadable-cheat-sheets-500.jpg'
              )
              button.setAttribute(
                'href',
                'https://pokercoaching.com/cheatsheets'
              )
              break
            case 'img6':
              image.setAttribute(
                'src',
                'https://pokercoaching.com/wp-content/uploads/2024/01/flowcharts-500.jpg'
              )
              button.setAttribute(
                'href',
                'https://pokercoaching.com/6flowcharts'
              )
              break
            case 'img7':
              image.setAttribute(
                'src',
                'https://pokercoaching.com/wp-content/uploads/2024/11/image-1-e1732726911139.png'
              )
              button.setAttribute(
                'href',
                'https://pokercoaching.com/poker-math'
              )
              break
            default:
              image.setAttribute(
                'src',
                'https://pokercoaching.com/wp-content/uploads/2024/01/poker-ebooks-500.jpg'
              )
              button.setAttribute(
                'href',
                'https://pokercoaching.com/poker-ebooks'
              )
              break
          }
        })
      })
    }
  }, [])
  useEffect(() => {
    window.swarmoptions = {
      swarmcdnkey: '9e39b196-bc18-4511-a2d9-6af7a74421bc',
      iframeReplacement: 'iframe',
      autoreplace: {
        youtube: false,
      },
      theme: {
        button: 'rectangle',
      },
    }
  }, [])
  return (
    <>
      <Layout>
        <SiteHeader />
        <main>
          <section className='section section-relative section-1'>
            <div className='section-fit section-relative'>
              <img
                className='item-absolute item-content-box item-block image section-1-image'
                alt=''
                src={jlImg}
              />
              <h1 className='item-absolute headline' id='element-1068'>
                <span>EVERYTHING YOU</span>
                <span>
                  NEED TO <span className='green'>CRUSH</span>
                </span>
              </h1>
              <div className='item-absolute hidden-mobile' id='element-1066'>
                <div className='cropped item-block' />
              </div>
              <div className='item-absolute hidden-desktop' id='element-1076'>
                <div className='cropped item-block'>
                  <img
                    className='item-content-box item-block image'
                    alt=''
                    src={wordsImg}
                  />
                </div>
              </div>
              <div className='item-absolute' id='element-1067'>
                <a href='/pricing/' className='btn item-block'>
                  Start Crushing With PokerCoaching »
                </a>
              </div>
            </div>
          </section>
          <section className='section section-relative section-2'>
            <div className='section-fit section-relative italic'>
              <p className='x_413de8b6 item-absolute' id='element-894'>
                <em>
                  <span>
                    &quot; I created PokerCoaching.com to help you learn from the
                    best poker players in the world. It’s the training site I
                    wish I had access to when I was first getting started. &quot;
                  </span>
                </em>
              </p>
              <p className='item-absolute' id='element-895'>
                <em>
                  <span>- Jonathan Little, Founder of PokerCoaching.com</span>
                </em>
              </p>
            </div>
          </section>
          <section className='section section-relative section-3'>
            <div className='section-inner section-fit section-relative'>
              <h1 className='item-absolute' id='element-1222'>
                JUST RELEASED
              </h1>
              <img
                className='item-content-box item-absolute item-block image img-lazy'
                id='element-1221'
                alt=''
                src={img14}
              />
            </div>
          </section>
          <section className='section section-relative section-4'>
            <div className='section-inner section-fit section-relative'>
              <div className='item-absolute section-4-video'>
                <div className='html-widget__text-center'>
                  <Script
                    async
                    src='https://assets.swarmcdn.com/cross/swarmdetect.js'
                  />
                  <smartvideo
                    src='https://jlsecrets.s3.amazonaws.com/videos/pk-promo.mp4'
                    width='1280'
                    height='720'
                    className='swarm-fluid'
                    poster='https://jlsecrets.s3.amazonaws.com/videos/peak-promo-thumb.jpg'
                    controls
                    playsInline
                  ></smartvideo>
                </div>
              </div>
            </div>
          </section>
          <section className='section section-relative section-5'>
            <div className='section-inner section-fit section-relative items-container'>
              <div className='item-container first'>
                <h1>LIBRARY</h1>
                <p>Study millions of preflop &amp;postflop GTO spots</p>
              </div>
              <div className='item-container second'>
                <h1>TRAINER</h1>
                <p>Over 20 million unique GTO spots to train</p>
              </div>
              <div className='item-container third'>
                <h1>DRILLS</h1>
                <p>
                  Master GTO with over 50 hand‑picked spots from top pros to
                  drill
                </p>
              </div>
              <div className='item-container fourth'>
                <h1>DRILL OF THE DAY</h1>
                <p>
                  Learn GTO the easy way with real time feedback from top pros
                </p>
              </div>
            </div>
          </section>
          <section className='section section-relative section-6'>
            <div className='section-inner section-fit section-relative'>
              <div className='widget item-absolute ' id='element-1178'>
                <a
                  href='https://peakgto.com'
                  id='link-osy2ylnv8u'
                  target='_blank'
                  className='url-link btn item-block'
                >
                  Elevate Your Game with PeakGTO »
                </a>
              </div>
            </div>
          </section>
          <section className='section section-relative section-7'>
            <div className='section-inner section-relative section-7-wrapper'>
              <h1>Changing The Lives of Poker Players</h1>
              <p className='subtitle'>
                Join the 209,283 poker players who have used PokerCoaching to
                elevate their game!
              </p>
              <div className='items-container'>
                <div className='item'>
                  <p>209,283</p>
                  <span>Poker Players</span>
                </div>
                <div className='item'>
                  <p>$207,121,728</p>
                  <span>Coach Earnings</span>
                </div>
                <div className='item'>
                  <p>16,607</p>
                  <span>Discord Members</span>
                </div>
                <div className='item'>
                  <p>6,542,092</p>
                  <span>Quizzes Taken</span>
                </div>
              </div>
            </div>
          </section>
          <section
            className='section section-relative'
            id='page-block-6gcfpd3ybau'
          >
            <div className='section-block'>
              <div className='section-inner section-fit section-relative'>
                <div className='widget item-absolute' id='element-934'>
                  <div className='contents cropped item-block'>
                    <img
                      className='item-content-box item-block image img-lazy'
                      alt=''
                      src={img10}
                    />
                  </div>
                </div>
                <div className='widget item-absolute headline' id='element-881'>
                  <div className='contents'>
                    <h1>
                      <span className='x_a76aec5f x_fc9d998b'>
                        <span className='x_abf10ad5'>CRUSH</span>&nbsp;
                        <span className='x_f2074b6c'>CASH GAMES.&nbsp;</span>
                        <span className='x_abf10ad5'>CRUSH</span>&nbsp;
                        <span className='x_f2074b6c'>TOURNAMENTS.&nbsp;</span>
                        <span className='x_abf10ad5'>CRUSH</span>&nbsp;
                        <span className='x_f2074b6c'>POKER.</span>
                      </span>
                    </h1>
                  </div>
                </div>
              </div>
            </div>
          </section>
          <section
            className='section section-relative'
            id='page-block-hzzt1plbjv'
          >
            <div className='section-block'>
              <div className='section-inner section-fit section-relative'>
                <div className='widget item-absolute' id='element-782'>
                  <div className='contents cropped item-block'>
                    <img
                      className='item-content-box item-block image img-lazy'
                      alt=''
                      src={checkIcon}
                    />
                  </div>
                </div>
                <div className='widget item-absolute' id='element-784'>
                  <div className='contents cropped item-block'>
                    <img
                      className='item-content-box item-block image img-lazy'
                      alt=''
                      src={checkIcon}
                    />
                  </div>
                </div>
                <div className='widget item-absolute' id='element-786'>
                  <div className='contents cropped item-block'>
                    <img
                      className='item-content-box item-block image img-lazy'
                      alt=''
                      src={checkIcon}
                    />
                  </div>
                </div>
                <div className='widget item-absolute' id='element-788'>
                  <div className='contents cropped item-block'>
                    <img
                      className='item-content-box item-block image img-lazy'
                      alt=''
                      src={checkIcon}
                    />
                  </div>
                </div>
                <div className='widget item-absolute headline' id='element-783'>
                  <div className='contents'>
                    <h1>
                      <span className='x_6858c20f x_8e98625a'>
                        ELITE COACHES
                      </span>
                    </h1>
                  </div>
                </div>
                <div className='widget item-absolute headline' id='element-785'>
                  <div className='contents'>
                    <h1>
                      <span className='x_6858c20f x_8e98625a'>
                        HAND QUIZZES
                      </span>
                    </h1>
                  </div>
                </div>
                <div className='widget item-absolute headline' id='element-787'>
                  <div className='contents'>
                    <h1>
                      <span className='x_6858c20f x_8e98625a'>
                        LIVE COACHING
                      </span>
                    </h1>
                  </div>
                </div>
                <div className='widget item-absolute headline' id='element-789'>
                  <div className='contents'>
                    <h1>
                      <span className='x_6858c20f x_8e98625a'>
                        VIDEO CLASSES
                      </span>
                    </h1>
                  </div>
                </div>
                <div className='widget item-absolute' id='element-790'>
                  <div className='contents cropped item-block'>
                    <img
                      className='item-content-box item-block image img-lazy'
                      alt=''
                      src={checkIcon}
                    />
                  </div>
                </div>
                <div className='widget item-absolute' id='element-792'>
                  <div className='contents cropped item-block'>
                    <img
                      className='item-content-box item-block image img-lazy'
                      alt=''
                      src={checkIcon}
                    />
                  </div>
                </div>
                <div className='widget item-absolute' id='element-794'>
                  <div className='contents cropped item-block'>
                    <img
                      className='item-content-box item-block image img-lazy'
                      alt=''
                      src={checkIcon}
                    />
                  </div>
                </div>
                <div className='widget item-absolute headline' id='element-791'>
                  <div className='contents'>
                    <h1>
                      <span className='x_6858c20f x_8e98625a'>
                        CASH GAME MASTERCLASS
                      </span>
                    </h1>
                  </div>
                </div>
                <div className='widget item-absolute headline' id='element-793'>
                  <div className='contents'>
                    <h1>
                      <span className='x_6858c20f x_8e98625a'>
                        TOURNAMENT MASTERCLASS
                      </span>
                    </h1>
                  </div>
                </div>
                <div className='widget item-absolute headline' id='element-795'>
                  <div className='contents'>
                    <h1>
                      <span className='x_6858c20f x_8e98625a'>
                        16.6K DISCORD MEMBERS
                      </span>
                    </h1>
                  </div>
                </div>
              </div>
            </div>
          </section>
          <section
            className='section section-relative'
            id='page-block-x3ptrviymi'
          >
            <div className='section-block'>
              <div className='section-inner section-fit section-relative'>
                <div className='widget item-absolute' id='element-878'>
                  <div className='contents html-widget__text-center'>
                    <smartvideo
                      src='https://jlsecrets.s3.amazonaws.com/videos/pc-home-page-2024.mp4'
                      width='1280'
                      height='720'
                      className='swarm-fluid'
                      poster='https://pokercoaching.com/wp-content/uploads/2024/12/poster-3.png'
                      controls
                      playsInline
                    ></smartvideo>
                  </div>
                </div>
              </div>
            </div>
          </section>
          <section
            className='section section-relative '
            id='page-block-2nuhwzbrlop'
          >
            <div className='section-block'>
              <div className='section-inner section-fit section-relative'>
                <div className='widget item-absolute ' id='element-1163'>
                  <a
                    href='/pricing/'
                    id='link-g8qwxqudtcm'
                    className='url-link btn item-block'
                  >
                    Start Crushing with PokerCoaching »
                  </a>
                </div>
              </div>
            </div>
          </section>
          <section
            className='section section-relative'
            id='page-block-azejggcemi9'
          >
            <div className='section-block'>
              <div className='section-inner section-fit section-relative'>
                <div
                  className='widget item-absolute headline'
                  id='element-1159'
                >
                  <div className='contents'>
                    <h1>
                      <span className='x_ed5d13c9 x_d5cc1063 italic'>
                        <em>
                          <nobr>
                            <span className='x_f2074b6c'>LEARN TO </span>
                            <span className='x_176ab628'>THINK AND PLAY</span>
                          </nobr>
                          <br />
                          <span className='x_f2074b6c'>
                            LIKE OUR ELITE PROS WITH
                            <br />
                            COMBINED EARNINGS OF
                          </span>
                        </em>
                      </span>
                    </h1>
                  </div>
                </div>
                <div
                  className='widget item-absolute headline'
                  id='element-1160'
                >
                  <div className='contents'>
                    <h1>
                      <span className='x_208dfe62 x_7f9b400a'>
                        <em>
                          <span className='x_176ab628 italic'>$207,121,728!</span>
                        </em>
                      </span>
                    </h1>
                  </div>
                </div>
              </div>
            </div>
          </section>
          <section
            className='section section-relative'
            id='page-block-zu0yjihmjcc'
          >
            <div className='section-block'>
              <div className='section-inner section-fit section-relative'>
                <div
                  className='widget item-absolute'
                  id='element-__gpage-block-zu0yjihmjcc-757'
                >
                  <div className='contents html-widget__text-center'>
                    <div>
                      <video
                        muted
                        loop
                        autoPlay
                        style={{ width: '100%', height: 'auto' }}
                      >
                        <source
                          src='https://jlsecrets.s3.amazonaws.com/videos/pc-coaches-1row-scrolling-solid-60fps.mp4'
                          type='video/mp4'
                        />
                      </video>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </section>
          <section
            className='section section-relative '
            id='page-block-v2kfwn1f0c'
          >
            <div className='section-block'>
              <div className='section-inner section-fit section-relative'>
                <div className='widget item-absolute ' id='element-873'>
                  <a
                    href='/pricing/'
                    id='link-cmcmiw6vbjs'
                    className='url-link btn item-block'
                  >
                    Start Crushing with PokerCoaching »
                  </a>
                </div>
              </div>
            </div>
          </section>
          <section
            className='section section-relative'
            id='page-block-2uwd8woivwp'
          >
            <div className='section-block'>
              <div className='section-inner section-fit section-relative'>
                <div
                  className='widget item-absolute headline '
                  id='element-1036'
                >
                  <div className='contents'>
                    <h1>
                      <span className='x_ed5d13c9 x_d5cc1063'>
                        <em>
                          <span className='x_f2074b6c italic'>
                            GET EVERYTHING YOU NEED TO MASTER
                          </span>
                        </em>
                      </span>
                    </h1>
                  </div>
                </div>
                <div
                  className='widget item-absolute headline'
                  id='element-1037'
                >
                  <div className='contents'>
                    <h1>
                      <span className='x_208dfe62 x_af7c46e8'>
                        <em>
                          <span className='x_176ab628 italic'>TOURNAMENTS</span>
                        </em>
                      </span>
                    </h1>
                  </div>
                </div>
              </div>
            </div>
          </section>
          <section
            className='section section-relative'
            id='page-block-dgkam1g5bx'
          >
            <div className='section-block'>
              <div className='section-inner section-fit section-relative'>
                <div
                  className='widget item-absolute headline '
                  id='element-__gpage-block-dgkam1g5bx-2369'
                >
                  <div className='contents'>
                    <h1>
                      <span className='x_a76aec5f x_d07fec43'>
                        TOURNAMENT MASTERCLASS
                      </span>
                    </h1>
                  </div>
                </div>
                <div
                  className='widget item-absolute headline'
                  id='element-__gpage-block-dgkam1g5bx-2370'
                >
                  <div className='contents'>
                    <h1>
                      <span className='x_a76aec5f x_d07fec43'>
                        HOW GIRAFGANGER WON $2,800,000
                      </span>
                    </h1>
                  </div>
                </div>
                <div
                  className='widget item-absolute headline'
                  id='element-__gpage-block-dgkam1g5bx-2371'
                >
                  <div className='contents'>
                    <h1>
                      <span className='x_a76aec5f x_d07fec43'>
                        HOW TO RUN DEEP IN LARGE FIELD TOURNAMENTS
                      </span>
                    </h1>
                  </div>
                </div>
                <div
                  className='widget item-absolute'
                  id='element-__gpage-block-dgkam1g5bx-2372'
                >
                  <div className='contents cropped item-block'>
                    <a
                      href='#cbfd634c41'
                      className='url-link item-content-box item-block'
                      id='link-oqy6x2bs47b-4'
                    />
                  </div>
                </div>
                <div
                  className='widget item-absolute'
                  id='element-__gpage-block-dgkam1g5bx-2373'
                >
                  <div className='contents cropped item-block'>
                    <a
                      href='#cb9a51ac18'
                      className='url-link item-content-box item-block'
                      id='link-2dq92mil4q4-4'
                    />
                  </div>
                </div>
                <div
                  className='widget item-absolute'
                  id='element-__gpage-block-dgkam1g5bx-2374'
                >
                  <div className='contents cropped item-block'>
                    <a
                      href='#cb1ac11761'
                      className='url-link item-content-box item-block'
                      id='link-jfzl5k4zx7h-4'
                    />
                  </div>
                </div>
              </div>
            </div>
          </section>
          <section
            className='section section-relative'
            id='page-block-97o9umdcf7g'
          >
            <div className='section-block'>
              <div className='section-inner section-fit section-relative'>
                <div
                  className='widget item-absolute headline '
                  id='element-__gpage-block-97o9umdcf7g-2378'
                >
                  <div className='contents'>
                    <h1>
                      <span className='x_a76aec5f x_d07fec43'>
                        ADVANCED TOURNAMENT COURSE
                      </span>
                    </h1>
                  </div>
                </div>
                <div
                  className='widget item-absolute headline'
                  id='element-__gpage-block-97o9umdcf7g-2379'
                >
                  <div className='contents'>
                    <h1>
                      <span className='x_a76aec5f x_d07fec43'>
                        HIGH STAKES TOURNAMENT SECRETS
                      </span>
                    </h1>
                  </div>
                </div>
                <div
                  className='widget item-absolute headline '
                  id='element-__gpage-block-97o9umdcf7g-2380'
                >
                  <div className='contents'>
                    <h1>
                      <span className='x_a76aec5f x_d07fec43'>
                        HOW TO CRUSH EVERY STAGE OF A TOURNAMENT
                      </span>
                    </h1>
                  </div>
                </div>
                <div
                  className='widget item-absolute'
                  id='element-__gpage-block-97o9umdcf7g-2381'
                >
                  <div className='contents cropped item-block'>
                    <a
                      href='#cb10ccab0d'
                      className='url-link item-content-box item-block'
                      id='link-3tzxrjgrrsq-5'
                    />
                  </div>
                </div>
                <div
                  className='widget item-absolute'
                  id='element-__gpage-block-97o9umdcf7g-2382'
                >
                  <div className='contents cropped item-block'>
                    <a
                      href='#cb5d6f7807'
                      className='url-link item-content-box item-block'
                      id='link-5xp3u7xyazb-5'
                    />
                  </div>
                </div>
                <div
                  className='widget item-absolute'
                  id='element-__gpage-block-97o9umdcf7g-2383'
                >
                  <div className='contents cropped item-block'>
                    <a
                      href='#cbb8cb25b0'
                      className='url-link item-content-box item-block'
                      id='link-lnrp57y4rzg-5'
                    />
                  </div>
                </div>
              </div>
            </div>
          </section>
          <section
            className='section section-relative'
            id='page-block-ql8f75lugff'
          >
            <div className='section-block'>
              <div className='section-inner section-fit section-relative'>
                <div className='widget item-absolute ' id='element-442'>
                  <a
                    href='/pricing/'
                    id='link-161s05t5u11'
                    className='url-link btn item-block'
                  >
                    Start Crushing with PokerCoaching »
                  </a>
                </div>
              </div>
            </div>
          </section>
          <section
            className='section section-relative'
            id='page-block-u76dgwbt957'
          >
            <div className='section-block'>
              <div className='section-inner section-fit section-relative'>
                <div
                  className='widget item-absolute headline'
                  id='element-1115'
                >
                  <div className='contents'>
                    <h1>
                      <span className='x_ed5d13c9 x_d5cc1063'>
                        <em>
                          <span className='x_f2074b6c italic'>
                            GET EVERYTHING YOU NEED TO MASTER
                          </span>
                        </em>
                      </span>
                    </h1>
                  </div>
                </div>
                <div
                  className='widget item-absolute headline'
                  id='element-1116'
                >
                  <div className='contents'>
                    <h1>
                      <span className='x_208dfe62 x_7f9b400a'>
                        <em>
                          <span className='x_176ab628 italic'>CASH GAMES</span>
                        </em>
                      </span>
                    </h1>
                  </div>
                </div>
              </div>
            </div>
          </section>
          <section
            className='section section-relative'
            id='page-block-fp56wh0b6fg'
          >
            <div className='section-block'>
              <div className='section-inner section-fit section-relative'>
                <div
                  className='widget item-absolute headline'
                  id='element-__gpage-block-fp56wh0b6fg-2320'
                >
                  <div className='contents'>
                    <h1>
                      <span className='x_a76aec5f x_d07fec43'>
                        CASH GAME MASTERCLASS
                      </span>
                    </h1>
                  </div>
                </div>
                <div
                  className='widget item-absolute headline'
                  id='element-__gpage-block-fp56wh0b6fg-2323'
                >
                  <div className='contents'>
                    <h1>
                      <span className='x_a76aec5f x_d07fec43'>
                        CASH GAME CHALLENGE
                      </span>
                    </h1>
                  </div>
                </div>
                <div
                  className='widget item-absolute headline'
                  id='element-__gpage-block-fp56wh0b6fg-2326'
                >
                  <div className='contents'>
                    <h1>
                      <span className='x_a76aec5f x_d07fec43'>
                        CRUSHING TOUGH CASH GAMES
                      </span>
                    </h1>
                  </div>
                </div>
                <div
                  className='widget item-absolute'
                  id='element-__gpage-block-fp56wh0b6fg-2329'
                >
                  <div className='contents cropped item-block'>
                    <a
                      href='#cb004c8010'
                      className='url-link item-content-box item-block'
                      id='link-gli77z6c0rd-6'
                    >
                      <img
                        className='item-content-box item-block image img-lazy'
                        alt=''
                        src={img5}
                      />
                    </a>
                  </div>
                </div>
                <div
                  className='widget item-absolute'
                  id='element-__gpage-block-fp56wh0b6fg-2337'
                >
                  <div className='contents cropped item-block'>
                    <a
                      href='#cbac744275'
                      className='url-link item-content-box item-block'
                      id='link-9nbhl4dthmm-6'
                    >
                      <img
                        className='item-content-box item-block image img-lazy'
                        alt=''
                        src={img6}
                      />
                    </a>
                  </div>
                </div>
                <div
                  className='widget item-absolute'
                  id='element-__gpage-block-fp56wh0b6fg-2338'
                >
                  <div className='contents cropped item-block'>
                    <a
                      href='#cba97064b9'
                      className='url-link item-content-box item-block'
                      id='link-5uzo0zdztp2-6'
                    >
                      <img
                        className='item-content-box item-block image img-lazy'
                        alt=''
                        src={img7}
                      />
                    </a>
                  </div>
                </div>
              </div>
            </div>
          </section>
          <section
            className='section section-relative'
            id='page-block-xsnqd2g5s7'
          >
            <div className='section-block'>
              <div className='section-inner section-fit section-relative'>
                <div
                  className='widget item-absolute headline'
                  id='element-__gpage-block-xsnqd2g5s7-2340'
                >
                  <div className='contents'>
                    <h1>
                      <span className='x_a76aec5f x_d07fec43'>
                        ADVANCED CASH GAME COURSE
                      </span>
                    </h1>
                  </div>
                </div>
                <div
                  className='widget item-absolute headline'
                  id='element-__gpage-block-xsnqd2g5s7-2341'
                >
                  <div className='contents'>
                    <h1>
                      <span className='x_a76aec5f x_d07fec43'>
                        HERO'S JOURNEY
                      </span>
                    </h1>
                  </div>
                </div>
                <div
                  className='widget item-absolute headline'
                  id='element-__gpage-block-xsnqd2g5s7-2342'
                >
                  <div className='contents'>
                    <h1>
                      <span className='x_a76aec5f x_d07fec43'>
                        BEATING LOOSE LIVE CASH GAMES
                      </span>
                    </h1>
                  </div>
                </div>
                <div
                  className='widget item-absolute'
                  id='element-__gpage-block-xsnqd2g5s7-2343'
                >
                  <div className='contents cropped item-block'>
                    <a
                      href='#cbec3fafa5'
                      className='url-link item-content-box item-block'
                      id='link-oqy6x2bs47b-7'
                    />
                  </div>
                </div>
                <div
                  className='widget item-absolute'
                  id='element-__gpage-block-xsnqd2g5s7-2344'
                >
                  <div className='contents cropped item-block'>
                    <a
                      href='#cb00fc9b99'
                      className='url-link item-content-box item-block'
                      id='link-2dq92mil4q4-7'
                    />
                  </div>
                </div>
                <div
                  className='widget item-absolute'
                  id='element-__gpage-block-xsnqd2g5s7-2345'
                >
                  <div className='contents cropped item-block'>
                    <a
                      href='#cbb8a96a7f'
                      className='url-link item-content-box item-block'
                      id='link-jfzl5k4zx7h-7'
                    />
                  </div>
                </div>
              </div>
            </div>
          </section>
          <section
            className='section section-relative'
            id='page-block-eupdwonfws'
          >
            <div className='section-block'>
              <div className='section-inner section-fit section-relative'>
                <div className='widget item-absolute' id='element-966'>
                  <a
                    href='/pricing/'
                    id='link-mim4s07na8'
                    className='url-link btn item-block'
                  >
                    Start Crushing with PokerCoaching »
                  </a>
                </div>
              </div>
            </div>
          </section>
          <section
            className='section section-relative'
            id='page-block-y8h0xuoc84j'
          >
            <div className='section-block'>
              <div className='section-inner section-fit section-relative'>
                <div
                  className='widget item-absolute headline'
                  id='element-1206'
                >
                  <div className='contents'>
                    <h1>
                      <span className='x_0a0a75ad x_64e665fe'>
                        <em>
                          <span className='x_f2074b6c italic'>
                            GET ACCESS TO OUR DISCORD COMMUNITY WITH
                          </span>
                        </em>
                      </span>
                    </h1>
                  </div>
                </div>
                <div
                  className='widget item-absolute headline'
                  id='element-1207'
                >
                  <div className='contents'>
                    <h1>
                      <span className='x_208dfe62 x_7f9b400a'>
                        <em>
                          <span className='x_176ab628 italic'>OVER 16,600</span>
                        </em>
                      </span>
                    </h1>
                  </div>
                </div>
                <div
                  className='widget item-absolute headline'
                  id='element-1208'
                >
                  <div className='contents'>
                    <h1>
                      <span className='x_0a0a75ad x_aaed72c5'>
                        <em>
                          <span className='x_f2074b6c italic'>MEMBERS!</span>
                        </em>
                      </span>
                    </h1>
                  </div>
                </div>
              </div>
            </div>
          </section>
          <section
            className='section section-relative'
            id='page-block-a0yz6x137cm'
          >
            <div className='section-block'>
              <div className='section-inner section-fit section-relative'>
                <div
                  className='widget item-absolute'
                  id='element-__gpage-block-a0yz6x137cm-718'
                >
                  <div className='contents cropped item-block' />
                </div>
              </div>
            </div>
          </section>
          <section
            className='section section-relative'
            id='page-block-hcfio5fbxkc'
          >
            <div className='section-block'>
              <div className='section-inner section-fit section-relative'>
                <div
                  className='widget item-absolute paragraph'
                  id='element-__gpage-block-hcfio5fbxkc-714'
                >
                  <div className='contents'>
                    <p className='x_84679fb3 x_b558b569'>
                      <span className='x_f2074b6c'>
                        Join now and get access to our Discord community over
                        16,600 like-minded members!&nbsp;Connect with other
                        members, share your experiences, attend our live study
                        sessions, and get advice and feedback from our coaches!
                      </span>
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </section>
          <section
            className='section section-relative'
            id='page-block-6m7z2iv90p5'
          >
            <div className='section-block'>
              <div className='section-inner section-fit section-relative'>
                <div className='widget item-absolute' id='element-715'>
                  <a
                    href='/pricing/'
                    id='link-ucpmu6kzfjo'
                    className='url-link btn item-block'
                  >
                    Start Crushing with PokerCoaching »
                  </a>
                </div>
              </div>
            </div>
          </section>
          <section
            className='section section-relative'
            id='page-block-4pp0wjs2c2q'
          >
            <div className='section-block'>
              <div className='section-inner section-fit section-relative'>
                <div className='widget item-absolute' id='element-1214'>
                  <div className='contents shape box figure' />
                </div>
                <div className='widget item-absolute ' id='element-1210'>
                  <div className='contents shape box figure' />
                </div>
                <div
                  className='widget item-absolute paragraph'
                  id='element-1211'
                >
                  <div className='contents'>
                    <p className='x_8b236db7 x_04a047ed'>
                      <span className='x_0c528ccb'>
                        "I've been playing poker for over 15 years, and
                        honestly, I've never seen results like this.
                      </span>
                    </p>
                    <p className='x_8b236db7 x_04a047ed'>
                      <span className='x_0c528ccb'>
                        <br />
                      </span>
                    </p>
                    <p className='x_8b236db7 x_04a047ed'>
                      <span className='x_0c528ccb'>
                        I purchased the Poker Coaching premium membership last
                        year. I remember feeling stuck after not making much of
                        a splash in a multi-part, week-long
                        tournament.&nbsp;Since then, I've really dived into the
                        content and got first place in the last two tournaments
                        I've entered!
                      </span>
                    </p>
                    <p className='x_8b236db7 x_04a047ed'>
                      <span className='x_0c528ccb'>
                        <br />
                      </span>
                    </p>
                    <p className='x_8b236db7 x_04a047ed'>
                      <span className='x_0c528ccb'>
                        I'm really enjoying putting everything I'm learning into
                        practice at the tables and playing an agressive, GTO
                        (and sometimes exploitative) play.&nbsp;The content you
                        provide has been incredible, and I'm super grateful."
                      </span>
                    </p>
                    <p className='x_8b236db7 x_04a047ed'>
                      <span className='x_f2074b6c' />
                    </p>
                    <p className='x_8b236db7 x_04a047ed'>
                      <span className='x_f2074b6c' />
                    </p>
                  </div>
                </div>
                <div className='widget item-absolute' id='element-1212'>
                  <div className='contents cropped item-block'>
                    <img
                      className='item-content-box item-block image img-lazy'
                      alt=''
                      src={img13}
                    />
                  </div>
                </div>
                <div
                  className='widget item-absolute paragraph'
                  id='element-1213'
                >
                  <div className='contents'>
                    <p className='x_1e7dedd6 x_40eda391'>
                      <strong className='x_8005b46a'>Anthony M.</strong>
                      <br />
                    </p>
                    <p className='x_1e7dedd6 x_40eda391'>
                      <span className='x_0c528ccb'>
                        <strong>PokerCoaching Premium Member</strong>
                      </span>
                    </p>
                    <p className='x_1e7dedd6 x_40eda391'>
                      <span className='x_f2074b6c' />
                    </p>
                    <p className='x_1e7dedd6 x_40eda391'>
                      <span className='x_f2074b6c' />
                    </p>
                  </div>
                </div>
                <div
                  className='widget item-absolute paragraph'
                  id='element-1215'
                >
                  <div className='contents'>
                    <p className='x_8b236db7 x_561aca13'>
                      <span className='x_0c528ccb'>
                        "Poker Coaching has helped my game improve immensely
                        since joining in June of this year.
                      </span>
                    </p>
                    <p className='x_8b236db7 x_561aca13'>
                      <span className='x_0c528ccb'>
                        <br />
                      </span>
                    </p>
                    <p className='x_8b236db7 x_561aca13'>
                      <span className='x_0c528ccb'>
                        Since June, I've cashed out a total of $213,323 with my
                        biggest cash out just this past Monday for $191K at the
                        SHRRPO in Hollywood.
                      </span>
                    </p>
                    <p className='x_8b236db7 x_561aca13'>
                      <span className='x_0c528ccb'>
                        <br />
                      </span>
                    </p>
                    <p className='x_8b236db7 x_561aca13'>
                      <span className='x_0c528ccb'>
                        I have to say that your courses helped me realize,
                        understand and improve on some really important concepts
                        of both tournaments and cash games.
                      </span>
                      <span className='x_0c528ccb'>"</span>
                    </p>
                    <p className='x_8b236db7 x_561aca13'>
                      <span className='x_f2074b6c' />
                    </p>
                    <p className='x_8b236db7 x_561aca13'>
                      <span className='x_f2074b6c' />
                    </p>
                  </div>
                </div>
                <div className='widget item-absolute' id='element-1216'>
                  <div className='contents cropped item-block'>
                    <img
                      className='item-content-box item-block image img-lazy'
                      alt=''
                      src={img11}
                    />
                  </div>
                </div>
                <div
                  className='widget item-absolute paragraph'
                  id='element-1217'
                >
                  <div className='contents'>
                    <p className='x_1e7dedd6 x_40eda391'>
                      <strong className='x_8005b46a'>Peter Hsu</strong>
                      <br />
                    </p>
                    <p className='x_1e7dedd6 x_40eda391'>
                      <span className='x_0c528ccb'>
                        <strong>PokerCoaching Premium Member</strong>
                      </span>
                    </p>
                    <p className='x_1e7dedd6 x_40eda391'>
                      <span className='x_f2074b6c' />
                    </p>
                    <p className='x_1e7dedd6 x_40eda391'>
                      <span className='x_f2074b6c' />
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </section>
          <section
            className='section section-relative'
            id='page-block-cu3xerflpdi'
          >
            <div className='section-block'>
              <div className='section-inner section-fit section-relative'>
                <div
                  className='widget item-absolute headline'
                  id='element-1054'
                >
                  <div className='contents'>
                    <h1>
                      <span className='x_0a0a75ad x_d5cc1063 italic'>
                        <em>
                          <span className='x_f2074b6c'>ARE YOU &nbsp;</span>
                        </em>
                        <em className='x_22d1fffd'>
                          <span className='x_f2074b6c'>READY TO START</span>
                        </em>
                      </span>
                    </h1>
                  </div>
                </div>
                <div
                  className='widget item-absolute headline'
                  id='element-1055'
                >
                  <div className='contents'>
                    <h1>
                      <span className='x_9fe66f35 x_7f9b400a'>
                        <em>
                          <span className='x_176ab628 italic'>CRUSHING?</span>
                        </em>
                      </span>
                    </h1>
                  </div>
                </div>
              </div>
            </div>
          </section>
          <section
            className='section section-relative'
            id='page-block-kb8reeysl2o'
          >
            <div className='section-block'>
              <div className='section-inner section-fit section-relative'>
                <div className='widget item-absolute' id='element-914'>
                  <div className='contents cropped item-block'>
                    <img
                      className='item-content-box item-block image img-lazy'
                      alt=''
                      src={coachesCollage}
                    />
                  </div>
                </div>
              </div>
            </div>
          </section>
          <section
            className='section section-relative'
            id='page-block-8rrfye6bhi'
          >
            <div className='section-block'>
              <div className='section-inner section-fit section-relative'>
                <div className='widget item-absolute' id='element-903'>
                  <a
                    href='/pricing/'
                    id='link-9i9chou1nua'
                    className='url-link btn item-block'
                  >
                    Start Crushing with PokerCoaching »
                  </a>
                </div>
              </div>
            </div>
          </section>
          <section
            className='section section-relative'
            id='page-block-gp6okeazk8r'
          >
            <div className='section-block'>
              <div className='section-inner section-fit section-relative'>
                <div
                  className='widget item-absolute headline'
                  id='element-1140'
                >
                  <div className='contents'>
                    <h1>
                      <span className='x_9317fdfd x_23a12c5a'>
                        <span className='x_f2074b6c'>POKER COURSES</span>
                      </span>
                    </h1>
                  </div>
                </div>
                <div
                  className='widget item-absolute headline'
                  id='element-1139'
                >
                  <div className='contents'>
                    <h1>
                      <span className='x_9317fdfd x_23a12c5a'>
                        <span className='x_f2074b6c'>ACCOUNT</span>
                      </span>
                    </h1>
                  </div>
                </div>
                <div className='widget item-absolute' id='element-1151'>
                  <div className='contents cropped item-block'>
                    <img
                      className='item-content-box item-block image img-lazy'
                      alt=''
                      src={pcLogo}
                    />
                  </div>
                </div>
                <div
                  className='widget item-absolute paragraph'
                  id='element-1152'
                >
                  <div className='contents'>
                    <p className='x_3579aa00 x_ebb3d042'>
                      <span className='x_7257c8fe'>
                        © 2025 PokerCoaching.com.&nbsp;
                      </span>
                      <span className='x_7257c8fe'>All Rights Reserved.</span>
                    </p>
                    <p className='x_3579aa00 x_ebb3d042'>
                      <span className='x_7257c8fe'>
                        <a
                          href='https://www.ncpgambling.org/'
                          id='link-vm9950qo5j8'
                          target='_blank'
                          className='url-link'
                        >
                          Please gamble responsibly.
                        </a>
                      </span>
                    </p>
                  </div>
                </div>
                <div
                  className='widget item-absolute paragraph'
                  id='element-1133'
                >
                  <div className='contents'>
                    <p className='x_3579aa00 x_ebb3d042'>
                      <span className='x_f2074b6c'>
                        <a
                          href='https://pokercoaching.com/cash-game-masterclass?ref=[ref]&utm_source=[utm_source]&utm_medium=[utm_medium]&utm_campaign=[utm_campaign]&utm_id=[utm_id]&utm_term=[utm_term]&_kx=[_kx]&utm_content=[utm_content]'
                          id='link-hmfpoj70le'
                          className='url-link'
                        >
                          Cash Game Masterclass
                        </a>
                      </span>
                    </p>
                  </div>
                </div>
                <div
                  className='widget item-absolute paragraph'
                  id='element-1134'
                >
                  <div className='contents'>
                    <p className='x_3579aa00 x_ebb3d042'>
                      <span className='x_f2074b6c'>
                        <a
                          href='https://pokercoaching.com/login/ref/[ref]/?utm_source=[utm_source]&utm_medium=[utm_medium]&utm_campaign=[utm_campaign]&utm_id=[utm_id]&utm_term=[utm_term]&_kx=[_kx]&utm_content=[utm_content]'
                          id='link-srhbhkd9res'
                          className='url-link'
                        >
                          Member Login
                        </a>
                      </span>
                    </p>
                  </div>
                </div>
                <div
                  className='widget item-absolute paragraph'
                  id='element-1136'
                >
                  <div className='contents'>
                    <p className='x_3579aa00 x_ebb3d042'>
                      <span className='x_f2074b6c'>
                        <a
                          href='https://pokercoaching.com/advanced-cash-game-course?ref=[ref]&utm_source=[utm_source]&utm_medium=[utm_medium]&utm_campaign=[utm_campaign]&utm_id=[utm_id]&utm_term=[utm_term]&_kx=[_kx]&utm_content=[utm_content]'
                          id='link-fazvk4oz6kg'
                          className='url-link'
                        >
                          Advanced Cash Game Course
                        </a>
                      </span>
                    </p>
                  </div>
                </div>
                <div
                  className='widget item-absolute paragraph'
                  id='element-1158'
                >
                  <div className='contents'>
                    <p className='x_3579aa00 x_ebb3d042'>
                      <span className='x_f2074b6c'>
                        <a
                          href='https://pokercoaching.com/pricing'
                          id='link-qqalqix6ha'
                          className='url-link'
                        >
                          Pricing
                        </a>
                      </span>
                    </p>
                  </div>
                </div>
                <div
                  className='widget item-absolute paragraph'
                  id='element-1135'
                >
                  <div className='contents'>
                    <p className='x_3579aa00 x_ebb3d042'>
                      <span className='x_f2074b6c'>
                        <a
                          href='https://pokercoaching.com/tournament-masterclass?ref=[ref]&utm_source=[utm_source]&utm_medium=[utm_medium]&utm_campaign=[utm_campaign]&utm_id=[utm_id]&utm_term=[utm_term]&_kx=[_kx]&utm_content=[utm_content]'
                          id='link-dsa6lgsazl5'
                          className='url-link'
                        >
                          Tournament Masterclass
                        </a>
                      </span>
                    </p>
                  </div>
                </div>
                <div
                  className='widget item-absolute paragraph'
                  id='element-1148'
                >
                  <div className='contents'>
                    <p className='x_3579aa00 x_ebb3d042'>
                      <span className='x_f2074b6c'>
                        <a
                          href='https://pokercoaching.com/privacy-policy/'
                          id='link-04m9zkocd1n8'
                          className='url-link'
                        >
                          Privacy Policy
                        </a>
                      </span>
                    </p>
                  </div>
                </div>
                <div
                  className='widget item-absolute paragraph'
                  id='element-1137'
                >
                  <div className='contents'>
                    <p className='x_3579aa00 x_ebb3d042'>
                      <span className='x_f2074b6c'>
                        <a
                          href='https://pokercoaching.com/advanced-tournament-course?ref=[ref]&utm_source=[utm_source]&utm_medium=[utm_medium]&utm_campaign=[utm_campaign]&utm_id=[utm_id]&utm_term=[utm_term]&_kx=[_kx]&utm_content=[utm_content]'
                          id='link-wecagf5lffp'
                          className='url-link'
                        >
                          Advanced Tournament Course
                        </a>
                      </span>
                    </p>
                  </div>
                </div>
                <div
                  className='widget item-absolute paragraph'
                  id='element-1149'
                >
                  <div className='contents'>
                    <p className='x_3579aa00 x_ebb3d042'>
                      <span className='x_f2074b6c'>
                        <a
                          href='https://pokercoaching.com/pages-legal-policies/'
                          id='link-efxbqn85rnj'
                          className='url-link'
                        >
                          Legal &amp;Policies
                        </a>
                      </span>
                    </p>
                  </div>
                </div>
                <div
                  className='widget item-absolute paragraph'
                  id='element-1138'
                >
                  <div className='contents'>
                    <p className='x_3579aa00 x_ebb3d042'>
                      <span className='x_f2074b6c'>
                        <a
                          href='https://pokercoaching.com/heros-journey?ref=[ref]&utm_source=[utm_source]&utm_medium=[utm_medium]&utm_campaign=[utm_campaign]&utm_id=[utm_id]&utm_term=[utm_term]&_kx=[_kx]&utm_content=[utm_content]'
                          id='link-pwpu0ozy5j'
                          className='url-link'
                        >
                          Hero's Journey
                        </a>
                      </span>
                    </p>
                  </div>
                </div>
                <div
                  className='widget item-absolute paragraph'
                  id='element-1150'
                >
                  <div className='contents'>
                    <p className='x_3579aa00 x_ebb3d042'>
                      <span className='x_f2074b6c'>
                        <a
                          href='https://pokercoaching.com/contact-us/'
                          id='link-2srqzp2g3im'
                          className='url-link'
                        >
                          Support
                        </a>
                      </span>
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </section>
        </main>
      </Layout>
    </>
  )
}

export default IndexPage

export const Head = () => (
  <>
    <title>PokerCoaching Home</title>
    <html className='page-index' />
  </>
)
